import React from 'react';
import './AdminDashboard.css';
import { FaMoneyBillWave, FaCar, FaStar, FaChartLine } from 'react-icons/fa';

const AdminDashboard = ({ appointments }) => {
    // 1. Calculate Turnover (CA) - Sum of 'prix' for 'termine' appointments
    // Note: Assuming 'prix' exists as Number. If string, parseFloat.
    const completedApts = appointments.filter(a => a.statut === 'termine');
    const turnover = completedApts.reduce((sum, apt) => sum + (Number(apt.prix) || 0), 0);

    // 2. Count Stats
    const totalWashes = completedApts.length;
    const pendingCount = appointments.filter(a => a.statut === 'en_attente').length;

    // 3. Top Prestations
    const prestationCounts = {};
    completedApts.forEach(apt => {
        prestationCounts[apt.prestation] = (prestationCounts[apt.prestation] || 0) + 1;
    });

    // Convert to array and sort
    const topPrestations = Object.entries(prestationCounts)
        .sort(([, a], [, b]) => b - a)
        .slice(0, 3); // Top 3

    return (
        <div className="admin-dashboard">
            <div className="stats-grid">
                <div className="stat-card blue">
                    <div className="stat-icon"><FaMoneyBillWave /></div>
                    <div className="stat-info">
                        <h3>Chiffre d'Affaires</h3>
                        <p className="stat-value">{turnover.toLocaleString('fr-FR')} €</p>
                        <span className="stat-sub">Sur les RDV terminés</span>
                    </div>
                </div>

                <div className="stat-card green">
                    <div className="stat-icon"><FaCar /></div>
                    <div className="stat-info">
                        <h3>Lavages Effectués</h3>
                        <p className="stat-value">{totalWashes}</p>
                        <span className="stat-sub">Depuis le début</span>
                    </div>
                </div>

                <div className="stat-card orange">
                    <div className="stat-icon"><FaChartLine /></div>
                    <div className="stat-info">
                        <h3>En Attente</h3>
                        <p className="stat-value">{pendingCount}</p>
                        <span className="stat-sub">Demandes à traiter</span>
                    </div>
                </div>
            </div>

            <div className="dashboard-charts-row">
                <div className="chart-card">
                    <h3>🏆 Top 3 Prestations</h3>
                    {topPrestations.length > 0 ? (
                        <div className="top-list">
                            {topPrestations.map(([name, count], index) => (
                                <div key={index} className="top-item">
                                    <div className="rank">#{index + 1}</div>
                                    <div className="name">{name}</div>
                                    <div className="count">{count} lavages</div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p className="no-data">Pas assez de données.</p>
                    )}
                </div>

                <div className="chart-card">
                    <h3>🚀 Objectifs du mois</h3>
                    <p>Objectif CA : 5000 €</p>
                    <div className="progress-bar-container">
                        <div className="progress-bar" style={{ width: `${Math.min((turnover / 5000) * 100, 100)}%` }}></div>
                    </div>
                    <small>{Math.round((turnover / 5000) * 100)}% atteint</small>
                </div>
            </div>
        </div>
    );
};

export default AdminDashboard;
